module.exports = __webpack_public_path__ + "img/9788962913743.978959f6.jpg";